var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-section"},[_c('b-field',{staticClass:"input-field",attrs:{"label":"Pivot measure columns by:"}},[_c('CompanyDimensionRefSelect',{model:{value:(_vm.inputs.dimension),callback:function ($$v) {_vm.$set(_vm.inputs, "dimension", $$v)},expression:"inputs.dimension"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }